import React from 'react'
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout/Layout'
import AuthForm from './components/Auth/AuthForm'
import Dashboard from './pages/Dashboard'
import CreateProject from './pages/CreateProject'
import Account from './pages/Account'
import Plan from './pages/Plan'
import SlideEditor from './components/SlideEditor/SlideEditor'
import PresentationMode from './pages/PresentationMode'
import PublicProfile from './pages/PublicProfile'
import TermsOfService from './pages/TermsOfService'
import PrivacyPolicy from './pages/PrivacyPolicy'
import './App.css'

// Import AI Service test utilities for development
import './utils/testOpenRouter'
import './utils/testImageService'
import './utils/testImageServiceBasic'
import './utils/testImageLibrary'

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/auth" element={<AuthForm />} />
          
          {/* Public routes - no authentication required */}
          <Route 
            path="/public/:id" 
            element={<PresentationMode isPublic={true} />} 
          />
          <Route 
            path="/profile/:username" 
            element={<PublicProfile />} 
          />
          <Route 
            path="/terms" 
            element={<TermsOfService />} 
          />
          <Route 
            path="/privacy" 
            element={<PrivacyPolicy />} 
          />
          
          {/* Full-screen routes - authentication required */}
          <Route 
            path="/editor/:id" 
            element={
              <ProtectedRoute>
                <SlideEditor />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/present/:id" 
            element={
              <ProtectedRoute>
                <PresentationMode />
              </ProtectedRoute>
            } 
          />
          
          {/* Layout routes - authentication required */}
          <Route 
            path="/" 
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="create" element={<CreateProject />} />
            <Route path="account" element={<Account />} />
            <Route path="plan" element={<Plan />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App